import { useState } from 'react'
import { bool, func, oneOf, string } from 'prop-types'
import { Icon } from '@winnin/winnin_ui.components.icon'

import './index.scss'

function MessageBox({ message, closeButton, type, style, onClose }) {
  const [visible, setVisible] = useState(true)

  function handleCloseMessageBox() {
    setVisible(false)
    if (onClose) {
      onClose()
    }
  }

  if (!visible) {
    return null
  }

  return (
    <div className={`message-box ${type} ${style}`}>
      <div className="message-box-icon">
        <Icon icon={type} />
      </div>

      <p className="message-box-message">
        {closeButton && (
          <button className="message-box-close" onClick={handleCloseMessageBox}>
            <Icon icon="close" />
          </button>
        )}

        {message}
      </p>
    </div>
  )
}

MessageBox.propTypes = {
  closeButton: bool,
  message: string.isRequired,
  style: oneOf(['alert', 'success', 'floating', 'info', '']),
  type: string,
  onClose: func,
}

MessageBox.defaultProps = {
  closeButton: false,
  style: '',
  type: '',
  onClose: null,
}

export default MessageBox
